import API from "api/client";
import { envConfig } from "config";

const { starRatingQuestionsAPI } = envConfig;

/**
 *
 * @param query {string|null}
 * @param page {number|string}
 * @param size {number|string}
 * @returns {Promise<{}>}
 */
const searchStarRatingQuestions = (query, page = 1, size = 10) => {
  return API.get(`${starRatingQuestionsAPI}`, {
    params: { query, page, size },
  }).then((res) => res.data);
};

/**
 *
 * @param request.category {string}
 * @param request.questionRefid {number|string}
 * @param request.localeCode {string}
 * @param request.label {string}
 * @returns {Promise<{}>}
 */
const updateStarRatingQuestion = (request, query, page = 1, size = 10) => {
  return API.put(`${starRatingQuestionsAPI}`, request, { params: { query, page, size } }).then((res) => res.data);
};

/**
 *
 * @param request.category {string}
 * @param request.questionRefid {number|string}
 * @param request.localeCode {string}
 * @param request.label {string}
 * @returns {Promise<{}>}
 */
const createStarRatingQuestion = (request, query, page = 1, size = 10) => {
  return API.post(`${starRatingQuestionsAPI}`, request, { params: { query, page, size } }).then((res) => res.data);
};

export default {
  search: searchStarRatingQuestions,
  update: updateStarRatingQuestion,
  create: createStarRatingQuestion,
};
